import AMEX from './assets/amex.svg';
import DINERS_CLUB from './assets/diners_club.svg';
import DISCOVER from './assets/discover.svg';
import ERROR_UNKNOWN from './assets/error_unknown.svg';
import JCB from './assets/jcb.svg';
import MAESTRO from './assets/maestro.svg';
import MASTER_CARD from './assets/master_card.svg';
import UNKNOWN from './assets/unknown.svg';
import VISA from './assets/visa.svg';

export const CardNumberComponent = {
    template: `
    <oo-input-container class="icon-left">
        <oo-input-icon
            icon-class="$ctrl.CreditCardIdentifierService.name"
            icon-valid-src="$ctrl.validAsset"
            icon-invalid-src="$ctrl.invalidAsset"
        ></oo-input-icon>
        <input
            autocomplete="cc-number"
            id="card-number-field"
            name="cardnumber"
            ng-model="$ctrl.currentPayment.cardNumber"
            ng-required="true"
            type="tel"
            ui-mask-placeholder-char="space"
            ui-mask="{{$ctrl.CreditCardIdentifierService.mask}}"
            ui-options="$ctrl.options"
            valid-card-number
        />
        <label>Card Number</label>
        <div ng-messages="$ctrl.form.cardnumber.$error">
            <div ng-messages-include="generic-messages"></div>
            <div ng-message="amex">American Express is not accepted</div>
            <div ng-message="ccError, mask">Enter a complete credit card number</div>
        </div>
    </oo-input-container>
    `,
    bindings: {
        currentPayment: '<',
        form: '<'
    },
    controller: class {
        constructor(CreditCardIdentifierService) {
            'ngInject';
            Object.assign(this, { CreditCardIdentifierService });
            this.metadata = {};
            this.options = { clearOnBlur: false, allowInvalidValue: true, addDefaultPlaceholder: false };
            this.assetMap = { AMEX, DISCOVER, MASTER_CARD, VISA, UNKNOWN, JCB, DINERS_CLUB, MAESTRO, };
            this.errorAssetMap = {
                UNKNOWN: ERROR_UNKNOWN
            };
        }

        get validAsset() {
            const cardName = this.CreditCardIdentifierService.name;
            return (cardName ? this.assetMap[cardName] : null) || this.assetMap.UNKNOWN;
        }

        get invalidAsset() {
            const cardName = this.CreditCardIdentifierService.name;
            return (
                cardName
                    ? this.errorAssetMap[cardName] || this.assetMap[cardName]
                    : null
            ) || ERROR_UNKNOWN;
        }
    }
};
